import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=db24ba02"
import script from "./PreviewImage.vue?vue&type=script&lang=js"
export * from "./PreviewImage.vue?vue&type=script&lang=js"
import style0 from "./PreviewImage.vue?vue&type=style&index=0&id=db24ba02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports